import { ref } from 'vue';
import { defineStore } from 'pinia';
import { DEVICE_STATUS_ACTIVE } from '@/config/device-status-tabs';

export type TrackerListStatusContext = 'trackers' | 'groupDetail';

const DEFAULT_STATUSES = [DEVICE_STATUS_ACTIVE];

/**
 * UI state for Active / Provisioned / Archived tabs, scoped per page context.
 */
export const useTrackersListStatusStore = defineStore('trackersListStatus', () => {
  const trackersSelectedStatuses = ref<string[]>([...DEFAULT_STATUSES]);
  const groupDetailSelectedStatuses = ref<string[]>([...DEFAULT_STATUSES]);

  function getSelectedStatuses(context: TrackerListStatusContext): string[] {
    const statuses =
      context === 'groupDetail'
        ? groupDetailSelectedStatuses.value
        : trackersSelectedStatuses.value;

    return statuses?.length ? [...statuses] : [...DEFAULT_STATUSES];
  }

  function setSelectedStatuses(
    context: TrackerListStatusContext,
    statuses: string[],
  ) {
    if (context === 'groupDetail') {
      groupDetailSelectedStatuses.value = statuses;
      return;
    }

    trackersSelectedStatuses.value = statuses;
  }

  function ensureDefaultStatuses(context: TrackerListStatusContext) {
    if (!getSelectedStatuses(context).length) {
      setSelectedStatuses(context, [...DEFAULT_STATUSES]);
    }
  }

  return {
    trackersSelectedStatuses,
    groupDetailSelectedStatuses,
    getSelectedStatuses,
    setSelectedStatuses,
    ensureDefaultStatuses,
  };
});

export function getTrackerListStatusContextForRoute(
  routeName?: string | null,
): TrackerListStatusContext {
  return routeName === 'GroupDetailsView' ? 'groupDetail' : 'trackers';
}
